














































































































import Vue from 'vue'
import { mapState } from 'vuex'

import {
  FindStacks,
  Stack,
  PatchSiplahAccount,
  GetSIPLAHStacks,
  SiplahAccount,
  GetSiplahAccount,
} from '@/api/cems'

export default Vue.extend({
  name: 'SIPLAH',
  data() {
    return {
      account: {} as SiplahAccount,
      stacks: [] as Stack[],
      testRunning: false,
    }
  },
  computed: {
    ...mapState('license', { license: 'detailLicense' }),
  },
  methods: {
    async findStacks() {
      this.stacks = await FindStacks(['Siplah'])
    },
    async getAccount() {
      this.account = await GetSiplahAccount()
    },

    async patchAccount() {
      await PatchSiplahAccount(this.account)
    },

    async testConnection() {
      this.testRunning = true
      try {
        const stacks = await GetSIPLAHStacks()
        this.$toast.success('Connection success')
        console.log(stacks)
      } catch (e) {
        this.$toast.error(
          'Connection failed or other problem.See console for more information.'
        )
        // eslint-disable-next-line
        console.log(e)
      }

      setTimeout(() => {
        this.testRunning = false
      }, 1000)
    },

    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    onFormSubmit(e: Event) {
      e.preventDefault()
      this.patchAccount()
    },

    onRowClick(stack: Stack) {
      this.$router.push(`/cems/setting/chimney/${stack.uid}/siplah`)
    },

    // allert
    disableAccountAllert() {
      localStorage.setItem('siplah_DAA', '1')
    },

    enableAccountAllert() {
      localStorage.removeItem('siplah_DAA')
    },
  },
  created() {
    this.findStacks()
    this.getAccount()
  },
})
